//#region src/compat/_internal/MAX_ARRAY_LENGTH.ts
const MAX_ARRAY_LENGTH = 4294967295;
//#endregion
export { MAX_ARRAY_LENGTH };
